export default "__VITE_ASSET__BWMNEcx___"